import { render } from "./OnlySidebarDark.vue?vue&type=template&id=60da11df&ts=true"
import script from "./OnlySidebarDark.vue?vue&type=script&lang=ts"
export * from "./OnlySidebarDark.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__